import {
  IconButton,
  withStyles,
} from '@material-ui/core';
import {
  ThemePalette,
} from '../../theme/types';

const DangerIconButton = withStyles({
  root: {
    color: ThemePalette.ERROR_COLOR,
    backgroundColor: 'transparent',
  },
  label: {
    textTransform: 'capitalize',
  },
})(IconButton);

export default DangerIconButton;
